import { useMutation, useQuery } from '@tanstack/react-query';
import { datadogRum } from '@datadog/browser-rum';
import { getAddressChangeStatus, startAddressChangeProcess } from '@/api/addressChange/addressChange';
import { APP_CONFIG } from '@/config';
import { BASE_PATH, FINO_PATH } from '@/domain/routes';
import { getLogger } from '@/utils/logger/logger';
import type { AddressChangeStatus } from '@/@types/addressChange';

const PAYMENT_URL = '/warenkorb/adresswechsel/zahlung/6596';
const ERROR_CODE_REQUIRES_PAYMENT = 'CB-BIZ-VIOLATION-0';

export const useStartAddressChangeProcess = () => {
  return useMutation(startAddressChangeProcess, {
    onError: (error: any) => {
      if (error?.responseBody?.code === ERROR_CODE_REQUIRES_PAYMENT) {
        const returnUrl = new URL(`${BASE_PATH}${FINO_PATH}`, APP_CONFIG.baseUrl);

        const paymentUrl = new URL(PAYMENT_URL, APP_CONFIG.baseUrl);
        paymentUrl.searchParams.set('returnUrl', returnUrl.toString());

        window.location.href = paymentUrl.toString();
      } else {
        getLogger('ADDRESS_CHANGE_SERVICE').error(error);
        const startAddressChangeProcessError = new Error('ADDRESS_CHANGE_SERVICE: ' + error.message);
        startAddressChangeProcessError.name = 'ADDRESS_CHANGE_SERVICE';
        datadogRum.addError(startAddressChangeProcessError);
      }
    },
  });
};

export const useGetAddressChangeStatus = (): {
  initializing: boolean;
  status?: AddressChangeStatus;
} => {
  const { isLoading, data, isError } = useQuery<AddressChangeStatus, Error>({
    queryKey: ['address-change-status'],
    queryFn: getAddressChangeStatus,
  });

  return {
    initializing: isLoading || isError,
    status: data,
  };
};
